<template>
    <div class="pm ">
        <el-row class="video-tree flex" >
            <el-col :span="treespan"  v-show="isright" :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
<!--                <left-tree @showData="showData"></left-tree>-->
                <left-tree @showData="showData"  ref="tree" :isuseSearch="false" :withPerson="true"></left-tree>
            </el-col>
            <el-col :span="rightspan"  style="height: 100%;min-width: 320px;width: 100%">
                <div class="p5">
                    <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>

                    <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="人员" v-model="vc_name"></el-input>
                    <el-select v-model="i_flag"  size="mini" filterable clearable>
                        <el-option v-for="item in typeList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <el-button class="marB10" icon="el-icon-search" circle @click="searchFun " size="mini" ></el-button>
                    <el-button class="marB10" @click="addNew" :class="baseerp+'btn'" size="mini":disabled="disadd">
                        新增
                    </el-button>
                    <el-button class="marB10" @click="deleteData " :class="baseerp+'btn'" size="mini" :disabled="disdel">
                        删除
                    </el-button>
                    <el-button class="marB10" @click="editRow" :class="baseerp+'btn'" size="mini" :disabled="disedit">
                        编辑
                    </el-button>
                    <el-button class="marB10" @click="saveAuthSet" :class="baseerp+'btn'" size="mini" :disabled="dissave">
                        保存
                    </el-button>
                </div>
                <el-table
                        class="mrt10"
                        ref="table"
                        size="mini"
                        :height="tableHeight"
                        border
                        :data="tableData"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        :highlight-current-row="true"
                        @row-click="rowClick"
                        :row-class-name="rowClassName"
                        style="width: 100%">
                    <el-table-column
                            label="序号"
                            align="center"
                            type="index">
                    </el-table-column>
                    <!--<el-table-column
                            align="center"
                            label="规则ID"
                            prop="stateTxt" show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            align="center"
                            label="开始时间"
                            prop="dt_start" show-overflow-tooltip>
                        <template slot-scope="scope" >
                            <el-date-picker
                                    v-if="scope.row.edit"
                                    v-model="scope.row.dt_start"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                            <span v-else>{{scope.row.dt_start}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="结束时间"
                            prop="dt_end" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-date-picker
                                    v-if="scope.row.edit"
                                    v-model="scope.row.dt_end"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                            <span v-else>{{scope.row.dt_end}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="姓名"
                            prop="vc_uname_auth" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="核算方式"
                            prop="i_flag">
                        <template slot-scope="scope" >
                            <el-select v-model="scope.row.i_flag" v-if="scope.row.edit"  size="mini" >
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.i_id">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.vc_flag}}</span>
                        </template>
                    </el-table-column><el-table-column
                        align="center"
                        label="是否核算激励"
                        prop="vc_ishs">
                    <template slot-scope="scope" >
                        <el-select v-model="scope.row.i_ishs" v-if="scope.row.edit"  size="mini" >
                            <el-option
                                    v-for="one in accountYorN"
                                    :key="one.id"
                                    :label="one.name"
                                    :value="one.id">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_ishs}}</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        label="核算基数"
                        prop="vc_jljs">
                    <template slot-scope="scope" >
                        <el-select v-model="scope.row.i_jljs" v-if="scope.row.edit&&scope.row.i_flag==3"  size="mini" >
                            <el-option
                                    v-for="one in accountBase"
                                    :key="one.id"
                                    :label="one.name"
                                    :value="one.id">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_jljs}}</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        label="核算系数"
                        prop="f_jlxs">
                    <template slot-scope="scope" >
                        <el-input-number :controls="false"v-if="scope.row.edit&&scope.row.i_flag==3" size="mini" v-model="scope.row.f_jlxs" ></el-input-number>
                        <span v-else>{{scope.row.f_jlxs}}</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        label="核算区域"
                        prop="i_isexport">
                    <template slot-scope="scope" >
                        <el-select v-model="scope.row.i_isexport" v-if="scope.row.edit"  size="mini" >
                            <el-option
                                    v-for="one in accountArea"
                                    :key="one.id"
                                    :label="one.name"
                                    :value="one.id">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_isexport}}</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        label="核算人员"
                        prop="vc_depts">
                    <template slot-scope="scope" >
<!--                        <el-input  v-model="scope.row.vc_depts" v-if="scope.row.edit" @focus="openTree(6)"></el-input>-->
                        <span  type="text"  v-if="scope.row.edit" size="mini" :class="'color409eff'"  @click="openTree(scope.row,6)">{{scope.row.vc_depts?scope.row.vc_depts:'选择人员'}}</span>
                        <span v-else>{{scope.row.vc_depts}}</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        label="核算品种"
                        prop="vc_products">
                    <template slot-scope="scope" >
<!--                        <el-input  v-model="scope.row.vc_product" v-if="scope.row.edit" @focus="openTree(3)"></el-input>-->
                        <span  type="text"  :class="'color409eff'"  v-if="scope.row.edit" size="mini" @click="openTree(scope.row,3)">
                            {{scope.row.vc_products?scope.row.vc_products:'选择品种'}}
                        </span>
                        <span v-else>{{scope.row.vc_products}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="核算公司"
                        prop="vc_companys">
                    <template slot-scope="scope" >
                        <span  :class="'color409eff'"  type="text"  v-if="scope.row.edit" size="mini" @click="openTree(scope.row,4)">
                            {{scope.row.vc_companys?scope.row.vc_companys:'选择公司'}}
                        </span>
<!--                        <el-input  v-model="scope.row.vc_companys" v-if="scope.row.edit" @focus="openTree(4)"></el-input>-->
                        <span v-else>{{scope.row.vc_companys}}</span>
                    </template>
                </el-table-column>
                    <el-table-column
                            align="center"
                            label="核算客户"
                            prop="vc_customers">
                        <template slot-scope="scope" >
                            <span :class="'color409eff'"  type="text"  v-if="scope.row.edit" size="mini" @click="openTransfer(scope.row,scope.$index,30)">
                                {{scope.row.vc_customers?scope.row.vc_customers:'选择核算客户'}}
                            </span>
<!--                            <el-input  v-model="scope.row.vc_customers" v-if="scope.row.edit" @focus="openTransfer(scope.row,scope.$index,30)"></el-input>-->
                            <span v-else>{{scope.row.vc_customers}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="不核算客户"
                            prop="vc_companys_not">
                        <template slot-scope="scope" >
                            <span  type="text" :class="'color409eff'"  v-if="scope.row.edit" size="mini" @click="openTransfer(scope.row,scope.$index,31)">
                                {{scope.row.vc_customers_not?scope.row.vc_customers_not:'选择不核算客户'}}
                            </span>
<!--                            <el-input  v-model="scope.row.vc_companys_not" v-if="scope.row.edit" @focus="openTransfer(scope.row,scope.$index,31)"></el-input>-->
                            <span v-else>{{scope.row.vc_customers_not}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="登记时间"
                            prop="dt_createtime" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="录入人"
                            prop="vc_lruname" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="用户状态"
                            prop="vc_ustate_auth" show-overflow-tooltip>
                    </el-table-column>
                </el-table>
                <el-pagination
                        class="fr page"
                        style="margin-top: 10px;text-align: right"
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="pageSize"
                        :total="pageTotal"
                        :page-size="pageCount">
                </el-pagination>
            </el-col>
        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="title"
                       width="80%"
                       class="minw840"
                       top="30px"
                       v-if="dialogTableVisibleW"
                       :visible.sync="dialogTableVisibleW"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <transfer-table :customertype="customertype" :transferData="transferData" :transferChooseData="transferChooseData" @getTransfer="getCustomerList" @getChhoseTransfer="getCAccCustomerList" @choosetran="choosetran" @close="transClose"></transfer-table>
            </el-dialog>
            <el-dialog :title="treetitle"
                       width="80%"
                       class="minw840"
                       top="30px"
                       v-if="dialogtreeVisibleW"
                       :visible.sync="dialogtreeVisibleW"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <transfer-tree @choosetree="choosetree" @close="treeClose" :datatype="datatype"  :pid="chooseRow.i_id" :treeChoooseData="treeChoooseData"></transfer-tree>
<!--               -->
            </el-dialog>
        </div>


    </div>

</template>

<script>
    import * as API from "./../api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    // import LeftTree from "../LeftTree";
    import LeftTree from "@/views/personInformation/LeftTree"//更换为人员信息公共部门树
    import TransferTable from "../compontents/TransferTable";
    import TransferTree from "../compontents/TransferTree";
    export default {
        name: "index",
        components: {TransferTable, LeftTree,TransferTree},
        data() {
            return {
                isright:true,//树显示按钮
                treetitle:'',
                disadd:false,
                dissave:false,
                disdel:false,
                disedit:false,
                datatype:'',
                customertype:'',
                title:'',
                // transferPage: { pageNo: 1, pageSize: 3, total: 6     },
                customerPage: { pageSize: 1, pageCount: 20, total: 0 ,search:''},
                dialogTableVisibleW:false,
                dialogtreeVisibleW:false,
                pageCount:10,
                pageSize:1,
                pageTotal:0,
                tableData:[],
                transferData:{},
                transferChooseData:[],
                treeChoooseData:[],
                tableHeight:0,//列表高度
                baseerp:'',
                treespan:4,
                rightspan:20,
                infomation:'',
                chooseRow:{},
                chooseIndex:0,
                typeList:[
                ],
                accountYorN:[{name:'核算',id:1},
                    {name:'不核算',id:0}],
                accountBase:[
                    {name:' ',id:0},
                    {name:'平均奖(金额)',id:1},
                    {name:'销售管理(数量)',id:2},
                    {name:'销售支持(数量)',id:3},
                    {name:'采购支持(数量)',id:4},
                ],
                accountArea:[
                    {name:'国内',id:0},
                    {name:'国外',id:1},
                    {name:'全部',id:2},
                ],
                accountRy:[],
                accountPz:[],
                accountGs:[],
                accountYw:[],
                accountKh:[],
                accountNkh:[],
                i_flag:'',vc_name:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.baseerp=baseerp
this.getRightTypeList()
            this.$nextTick(()=>{
                this.onResize();

            })

        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            searchFun(){
                this.pageSize = 1
                this.disadd=false
                this.disdel=false
                this.disedit=false
                this.chooseRow={}
                this.getAuthSetList()
            },
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            rowClick(row){
                if (!this.chooseRow.edit){
                    this.chooseRow=row;
                    this.chooseIndex=row.index;
                }
            },
            async getAuthSetList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let i_gid_auth=0,i_uid_auth=0;
                if (this.infomation&&this.infomation.nodeType==0){
                    i_uid_auth=this.infomation.value;
                }else {
                    i_gid_auth=this.infomation.value;

                }
                let param = {
                    i_mid: this.mid,
                    page_count:this.pageCount,
                    page_size:this.pageSize,
                    i_uid_auth:i_uid_auth,
                    i_gid_auth:i_gid_auth,
                    i_flag:this.i_flag,
                    vc_search:this.vc_name
                };
                let res = await API.getAuthSetList(param);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.pageTotal=res.count
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            addNew(){
                // console.log(this.infomation,'this.infomation')

                if (this.infomation&&this.infomation.nodeType==0){
                    this.disadd=true
                    this.disdel=true
                    this.disedit=true
                    this.tableData.unshift({
                        i_id:0,
                        vc_uname_auth:this.infomation.label,
                        dt_start:this.getDateYYYYMMdd(),
                        dt_end:'2099-12-31',
                        edit:true,
                        i_jljs:0,
                        f_jlxs:0,
                        i_flag:this.typeList[0].i_id,
                        i_isexport:0,
                        i_ishs:1,
                        vc_lruname:sessionStorage.getItem("lruname"),
                        dt_createtime:this.getDateYYYYMMdd(),
                        // vc_ustate_auth:this.infomation.vc_ustate_auth,
                        i_uid_auth:this.infomation.value,


                    })
                    this.chooseRow=this.tableData[0]
                    this.chooseIndex=0
                }else{
                    this.$message.warning('请选择具体人员')
                }

            },
            openTransfer(row,index,type){
                // this.title=type==30?'选择核算客户':'选择不核算客户'
                this.dialogTableVisibleW=true
                this.customertype=type
                if (type==30){
                    this.title='选择核算客户'
                    this.transferChooseData=row.kh?row.kh:[]
                }else if (type==31){
                    this.title='选择不核算客户'
                    this.transferChooseData=row.nokh?row.nokh:[]
                }
                this.getCustomerList();
                // this.getCAccCustomerList();
                // console.log(row,index,'row,index')
            },
            choosetran(val,type){
                // console.log(val,'this.tableData')
                if (type==30){
                    this.tableData[this.chooseIndex].kh=val
                }else if (type==31){
                    this.tableData[this.chooseIndex].nokh=val
                }
                let text=val.filter(one=>one.flag==0||one.flag==1);
                if(text.length>0) {
                    if (type==30){
                        this.tableData[this.chooseIndex].vc_customers=text.map(one=>{
                            return one.label
                        }).join(';')
                    }else if (type==31){
                        this.tableData[this.chooseIndex].vc_customers_not=text.map(one=>{
                            return one.label
                        }).join(';')
                    }
                }else{
                    if (type==30){
                        this.tableData[this.chooseIndex].vc_customers=''
                    }else if (type==31){
                        this.tableData[this.chooseIndex].vc_customers_not=''
                    }
                }

                this.$set(this.tableData,this.chooseRow.index,this.chooseRow)
                this.transClose();
            },
            transClose(){
                this.dialogTableVisibleW=false
            },
            choosetree(val,type){
                // console.log(val,'this.tableData')
                if (type==3){
                    this.tableData[this.chooseIndex].pz=val

                }else if (type==4){
                    this.tableData[this.chooseIndex].gs=val

                }else if (type==6){
                    this.tableData[this.chooseIndex].ry=val
                }
                let text=val.filter(one=>one.flag==0||one.flag==1);
                if(text.length>0) {
                    if (type==3){
                        this.tableData[this.chooseIndex].vc_products=text.map(one=>{
                            return one.label
                        }).join(';')

                    }else if (type==4){
                        this.tableData[this.chooseIndex].vc_companys=text.map(one=>{
                            return one.label
                        }).join(';')
                    }else if (type==6){
                        this.tableData[this.chooseIndex].vc_depts=text.map(one=>{
                            return one.label
                        }).join(';')
                    }
                }else{
                    if (type==3){
                        this.tableData[this.chooseIndex].vc_products=''
                    }else if (type==4){
                        this.tableData[this.chooseIndex].vc_companys=''
                    }else if (type==6){
                        this.tableData[this.chooseIndex].vc_depts=''
                    }
                }

                this.$set(this.tableData,this.chooseRow.index,this.chooseRow)

                this.treeClose();
            },
            treeClose(){
                this.dialogtreeVisibleW=false
            },
            editRow(){
                // console.log(this.chooseRow,'this.chooseRow')
                if(JSON.stringify(this.chooseRow)!=='{}'){
                    this.getAuthPSetSubList(3)
                    this.getAuthPSetSubList(4)
                    this.getAuthPSetSubList(6)
                    this.getAuthPSetSubList(30)
                    this.getAuthPSetSubList(31)
                    this.disadd=true
                    this.disdel=true
                    this.disedit=true
                    // this.tableData[this.chooseRow.index].edit=true
                    // this.$set(this.tableData,this.chooseRow.index,this.chooseRow)
                    this.$set(this.tableData[this.chooseRow.index],'edit',true);

                }else{
                    this.$message.error('请选择要编辑的数据')
                }
            },
            deleteData(){
                if(JSON.stringify(this.chooseRow)!=='{}' ) {
                    this.$confirm('是否删除该项', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        this.tableData.splice(this.chooseRow.index, 1)
                        this.delAuthSet();
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
                }else{
                    this.$message.warning('请选择要删除的数据')
                }
            },
            showData(val){
                this.pageSize = 1

                this.infomation=val
                this.disadd=false
                this.disdel=false
                this.disedit=false
                this.chooseRow={}

                this.getAuthSetList()
            },
            openTree(row,type){
                this.datatype=type
                if (type==3){
                    this.treetitle='选择产品'
                    this.treeChoooseData=row.pz?row.pz:[]

                }else if (type==4){
                    this.treetitle='选择公司'
                    this.treeChoooseData=row.gs?row.gs:[]

                }else if (type==6){
                    this.treetitle='选择部门/人员'
                    this.treeChoooseData=row.ry?row.ry:[]

                }
                this.dialogtreeVisibleW=true
            },

            async getCAccCustomerList(search=''){
                let param = {
                    i_mid: this.mid,
                    vc_search: search,
                    i_type:this.customertype
                    // i_type:6,
                };
                let res = await API.getCAccCustomerList(param);
                if (res.code == 1) {
                this.transferChooseData=res.data
                // this.transferTotal=res.count
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getRightTypeList(){
                let param = {
                    i_mid: this.mid,
                    i_type:0,
                };
                let res = await API.getRightTypeList(param);
                if (res.code == 1) {
                    this.typeList=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getCustomerList(pagesize=1,search=''){

                let param = {
                    i_mid: this.mid,
                    page_count:20,
                    page_size:pagesize,
                    vc_search: search,
                    i_uid_auth:this.chooseRow.i_uid_auth,

                    // i_type:6,
                };
                let res = await API.getCustomerList(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                // i_pid:one.i_pid,
                                rightCheck:false,
                                i_ustate_auth:one.i_ustate_auth,
                            };
                            list.push(hash);
                        })
                    }
                    this.transferData={
                        list:list,
                        total:res.count,
                        pid:this.chooseRow.i_id
                    }
                    // console.log(this.transferData,'this.transferData')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getAuthPSetSubList(type){
                let param = {
                    i_mid: this.mid,
                    i_pid:this.chooseRow.i_id,
                    i_type:type
                    // i_type:6,
                };
                let res = await API.getAuthPSetSubList(param);
                if (res.code == 1) {
                    let list=[]
                    if (res.data.length>0){
                        list=res.data;
                        list.map(one=>{
                            one.label=one.vc_obj_name
                        })
                    }
                    if (type==3){
                        this.chooseRow.pz=list
                    }else if (type==4){
                        this.chooseRow.gs=list
                    }else if (type==6){
                        this.chooseRow.ry=list
                    }else if (type==30){
                        this.chooseRow.kh=list
                    }else if (type==31){
                        this.chooseRow.nokh=list
                    }
                    // this.transferTotal=res.count
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async saveAuthSet(){
                if(JSON.stringify(this.chooseRow)!=='{}'&&this.chooseRow.edit==true) {
                    if (!this.chooseRow.i_flag){
                        this.$message.warning('请选择核算方式')
                        return
                    }
                    let arr = [];
                    let obj = {
                        i_id: this.chooseRow.i_id,
                        i_pid: this.chooseRow.i_pid,
                        i_obj: '',
                        i_type: 6,
                        i_state: '',
                    };
                    arr = this.chooseRow.ry && this.chooseRow.ry.length != 0 ? arr.concat(this.chooseRow.ry) : arr
                    arr = this.chooseRow.gs && this.chooseRow.gs.length != 0 ? arr.concat(this.chooseRow.gs) : arr
                    arr = this.chooseRow.kh && this.chooseRow.kh.length != 0 ? arr.concat(this.chooseRow.kh) : arr
                    arr = this.chooseRow.nokh && this.chooseRow.nokh.length != 0 ? arr.concat(this.chooseRow.nokh) : arr
                    arr = this.chooseRow.pz && this.chooseRow.pz.length != 0 ? arr.concat(this.chooseRow.pz) : arr
                    // this.chooseRow.sublis= Array.from(new Set([...this.chooseRow.ry, ...this.chooseRow.gs, ...this.chooseRow.kh,...this.chooseRow.nokh, ...this.chooseRow.pz]));
                    // console.log(this.chooseRow,'chooseRow')
                    let param = {
                        i_mid: this.mid,
                        // i_uid_auth:this.infomation.value,
                        i_uid_auth: this.chooseRow.i_uid_auth,
                        vc_uname_auth: this.infomation.label,
                        // vc_ustate_auth: this.infomation.vc_ustate_auth,
                        i_id: this.chooseRow.i_id,
                        dt_start: this.chooseRow.dt_start,
                        dt_end: this.chooseRow.dt_end,
                        i_flag: this.chooseRow.i_flag,
                        i_jljs: this.chooseRow.i_jljs,
                        i_ishs: this.chooseRow.i_ishs,
                        f_jlxs: this.chooseRow.f_jlxs,
                        i_isexport: this.chooseRow.i_isexport,
                        dt_createtime: this.chooseRow.dt_createtime,
                        lururen: this.chooseRow.vc_lruname,
                        sublist: arr,
                        // i_type:6,
                    };
                    let res = await API.saveAuthSet(param);
                    if (res.code == 1) {
                        this.disadd = false
                        this.disdel = false
                        this.disedit = false
                        this.pageSize = 1
                        this.chooseRow = {}
                        this.getAuthSetList()
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            async delAuthSet(){
                this.dissave=true
                let i_idList=[],idinfo={i_id:this.chooseRow.i_id,i_uid_auth:this.chooseRow.i_uid_auth,}
                i_idList.push(idinfo)
                let param = {
                    i_mid: this.mid,
                    // i_uid_auth:this.infomation.i_state,
                    idList:i_idList,

                    // i_type:6,
                };
                let res = await API.delAuthSet(param);
                if (res.code == 1) {
                    this.disadd=false
                    this.disdel=false
                    this.disedit=false
                    this.dissave=false
                    this.chooseRow = {}
                    this.pageSize = 1
                    this.getAuthSetList()
                } else if (res.code == -2) {
                    this.dissave=false
                    this.disadd=false
                    this.disdel=false
                    this.disedit=false
                    this.chooseRow = {}

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.dissave=false
                    this.disadd=false
                    this.disdel=false
                    this.disedit=false
                    this.chooseRow = {}

                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val) {
                this.pageSize=val;
                this.getAuthSetList()
            },
            getDateYYYYMMdd(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
        },
    }
</script>

<style lang="scss" scoped>

    .flex{
        display: flex;
    }
    .p5{
        padding: 5px 0;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }
    .color409eff{
        color: var(--light) !important;
        display: inline-block;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
</style>